import Component from '@bythepixel/component-loader';
import DEFAULTS from '@Front/components/observer/_config';
import { handleComponentError } from '@Core/helpers/functions';

export default class Observer extends Component {
  static selector = `[${DEFAULTS.observee}]`;

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.mount();
  }

  mount() {
    this.observee = this.$container;
    const threshold = this.observee.getAttribute(this.$options.observeeThreshold)?.split(',').map(Number) ?? [0.1];

    this.observer = new IntersectionObserver(
      (entries => this.handleIntersections(entries)),
      {
        threshold,
      },
    );

    this.observer.observe(this.observee);
  }

  handleIntersections(entries) {
    entries.forEach((entry) => {
      const observeOnce = entry.target.getAttribute(this.$options.observee) === 'once';
      const observeeCallback = entry.target.getAttribute(this.$options.observeeCallback);

      if (entry.isIntersecting && observeOnce) {
        this.observer.disconnect();
      }

      entry.target.classList.toggle(this.$options.observedClass, entry.isIntersecting);

      if (typeof this[observeeCallback] === 'function') {
        this[observeeCallback](entry);
      }
    });
  }

  playbackOnView(entry) {
    handleComponentError([
      [
        this.observee.tagName !== 'VIDEO',
        'Cannot play or pause a non-video element.',
        this.observee,
      ],
    ]);

    if (entry.isIntersecting) {
      this.observee.play();
      return;
    }

    this.observee.pause();
  }

  parallaxOnView(entry) {
    this.setParallaxOffset();

    if (entry.isIntersecting) {
        window.addEventListener('scroll', this.handleParallax);
        return;
      }

      window.removeEventListener('scroll', this.handleParallax);
  }

  setParallaxOffset () {
    const rect = this.observee.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const elementBaseline = rect.top + rect.height / 2;
    const scrollPercentage = (elementBaseline - viewportHeight / 2) / (viewportHeight / 2);
    const clampedPercentage = Math.max(-1, Math.min(1, scrollPercentage));

    this.observee.style.setProperty('--parallax-offset', `${clampedPercentage}`);
  }

  handleParallax = () => {
    if (this.timeout) {
      return;
    }

    this.timeout = setTimeout(() => {
      this.setParallaxOffset();
      clearTimeout(this.timeout);
      this.timeout = null;
    }, 1000 / 60);
  };
}
